<template>
  <v-row v-if="result.uid" no-gutters>
    <v-col cols="12" md="8">
      <div class="major-steps__wrapper mb-5">
        <h3
          class="body-1 mb-2 mt-2 ml-0 ml-md-2 primary--text text-center text-md-start"
          v-translate="'details.titles.majorSteps'"
        >Major steps</h3>
        <v-row class="major-steps justify-center justify-lg-start mr-0 mr-md-2" no-gutters>
          <v-col
            cols="4"
            md="2"
            v-for="(s, index) in steps"
            :key="index"
            class="mt-2 mt-md-0"
          >
            <div class="major-steps__item">
              <div
                class="major-steps__status body-2 text-center grey lighten-2 py-1"
                v-translate="`details.majorSteps.${s.type}`"
              >
                {{ _.get(s, 'type') }}
              </div>
              <div class="major-steps__image">
                <img :src="icon(_.get(s, 'type'))" alt="">
                <div class="major-steps__hover caption d-flex align-center pa-2">
                  <div class="major-steps__hover-wrap">
                    <p class="text-center mb-4">
                      {{ [s.to.name, s.to.postalCode].filter(Boolean).join(' - ') }}
                    </p>
                    <p class="text-center mb-0">
                      {{
                        s.dates.actualEnd ||
                        s.dates.actualStart ||
                        s.dates.plannedEnd ||
                        s.dates.plannedStart
                        | datetime
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="major-steps__date caption grey lighten-2 text-center py-1"
                :style="complete(s)"
              >
                <span class="black--text">
                  {{ isComplete(s) ? "Act." : "Est." }}
                </span>
                <span class="font-italic">
                  {{
                    isComplete(s)
                      ? s.dates.actualEnd || s.dates.actualStart
                      : s.dates.plannedEnd || s.dates.plannedStart
                    | date
                  }}
                </span>
              </div>
            </div>
          </v-col>
          <v-col
            class="major-steps__empty caption grey--text"
            v-if="!steps.length"
            v-translate="'details.notFound'"
          >
            No major step for the current shipment had been found.
          </v-col>
        </v-row>
      </div>

      <div class="shipment-details__wrapper">
        <v-row>
          <v-col cols="5" class="align-center d-flex">
            <h3
              class="body-1 mb-4 primary--text"
              v-translate="'details.titles.shipmentDetails'"
            >Shipment details
            </h3>
          </v-col>
          <v-col>
            <v-spacer></v-spacer>
          </v-col>
          <!--
          [deprecated]: Not needed anymore for now. Has an issue when changing
          from a shipment to another, it doesn't hide the DI button if no info
          was found for the current shipment. -->

          <v-col
            v-if="scope.name.includes('IBM') && haveDynamicAccess"
            cols="6" class="justify-end d-flex pr-0 pr-md-3">
            <div class="mb-4 mr-2 fluid">
              <ItineraryModal :processID="_.get(order, 'shipment')"/>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-none d-md-block">
            <h4 class="subtitle-2 mb-2">
              <v-icon size="18" color="#3200E6">mdi-upload</v-icon>
              {{ 'general.origin' | translate }}:
            </h4>
            <p class="mb-0 caption font-weight-bold">{{ _.get(from, 'name') }}</p>
            <p class="mb-0 caption grey--text">{{ _.get(from, 'address') }}</p>
            <p class="mb-0 caption">{{ _.get(from, 'state') }}</p>
            <p class="mb-0 caption">{{ _.get(from, 'postalCode') }} {{ _.get(from, 'city') }}</p>
            <p class="mb-0 caption">{{ _.get(from, 'country') }}</p>
            <h4
              v-translate="`details.titles.departure`"
              class="subtitle-2 grey--text font-weight-regular">
              Departure:
            </h4>
            <p class="mb-0 caption">
              {{this.$lang.translate('details.dates.plannedStart')}}
              {{ _.get(from, 'plannedStart') | datetime }}
            </p>
            <p
              class="mb-0 caption primary--text"
              v-if="setActualDate('First', _.get(from, 'actualStart'))"
            >
              {{this.$lang.translate('details.dates.actualStart')}}
              {{setActualDate('First', _.get(from, 'actualStart')) | datetime}}
            </p>
          </v-col>
          <v-col class="d-none d-md-block">
            <h4 class="subtitle-2 mb-2">
              <v-icon size="18" color="#3200E6">mdi-download</v-icon> Destination:
            </h4>
            <p class="mb-0 caption font-weight-bold">{{ _.get(to, 'name') }}</p>
            <p class="mb-0 caption grey--text">{{ _.get(to, 'address') }}</p>
            <p class="mb-0 caption">{{ _.get(to, 'state') }}</p>
            <p class="mb-0 caption">{{ _.get(to, 'postalCode') }} {{ _.get(to, 'city') }}</p>
            <p class="mb-0 caption">{{ _.get(to, 'country') }}</p>
            <h4
              v-translate="`details.titles.delivery`"
              class="subtitle-2 grey--text font-weight-regular"
            >Delivery:</h4>
            <p class="mb-0 caption">
              {{this.$lang.translate('details.dates.plannedEnd')}}
              {{ _.get(to, 'plannedEnd') | datetime }}
            </p>
            <p
              class="mb-0 caption primary--text"
              v-if="setActualDate('Last', _.get(to, 'actualEnd'))"
            >
              {{this.$lang.translate('details.dates.actualEnd')}}
              {{setActualDate('Last', _.get(to, 'actualEnd')) | datetime}}
            </p>
          </v-col>
          <v-col class="d-none d-md-block">
            <ul class="geodis-data">
              <li class="geodis-data__item" v-for="d in referencesBySystem" :key="d.uid">
                <v-row>
                  <v-col class="py-0">
                    <span class="body-2 grey--text">
                      {{ d.lang ? d.lang : d.name }}:
                    </span>
                  </v-col>
                  <v-col class="py-0">
                    <span class="body-2">
                      {{ _.get(order, d.alias) || lookForReference(d.alias) || '' }}
                    </span>
                  </v-col>
                </v-row>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" class="d-block d-md-none">
            <v-expansion-panels focusable>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h4 class="subtitle-2 mb-2">
                    <v-icon size="20" color="#3200E6">mdi-upload</v-icon>
                    {{ 'general.origin' | translate }}
                  </h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p class="mb-0 caption font-weight-bold">{{ _.get(from, 'name') }}</p>
                  <p class="mb-0 caption grey--text">{{ _.get(from, 'address') }}</p>
                  <p class="mb-0 caption">{{ _.get(from, 'state') }}</p>
                  <p class="mb-0 caption">
                    {{ _.get(from, 'postalCode') }} {{ _.get(from, 'city') }}
                  </p>
                  <p class="mb-0 caption">{{ _.get(from, 'country') }}</p>
                  <h4
                    v-translate="`details.titles.departure`"
                    class="subtitle-2 grey--text font-weight-regular">
                    Departure:
                  </h4>
                  <p class="mb-0 caption">
                    {{this.$lang.translate('details.dates.plannedStart')}}
                    {{ _.get(from, 'plannedStart') | datetime }}
                  </p>
                  <p
                    class="mb-0 caption primary--text"
                    v-if="setActualDate('First', _.get(from, 'actualStart'))"
                  >
                    {{this.$lang.translate('details.dates.actualStart')}}
                    {{setActualDate('First', _.get(from, 'actualStart')) | datetime}}
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h4 class="subtitle-2 mb-2">
                    <v-icon size="20" color="#3200E6">
                    mdi-download
                    </v-icon> Destination</h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p class="mb-0 caption font-weight-bold">{{ _.get(to, 'name') }}</p>
                  <p class="mb-0 caption grey--text">{{ _.get(to, 'address') }}</p>
                  <p class="mb-0 caption">{{ _.get(to, 'state') }}</p>
                  <p class="mb-0 caption">{{ _.get(to, 'postalCode') }} {{ _.get(to, 'city') }}</p>
                  <p class="mb-0 caption">{{ _.get(to, 'country') }}</p>
                  <h4
                    v-translate="`details.titles.delivery`"
                    class="subtitle-2 grey--text font-weight-regular">
                    Delivery:
                  </h4>
                  <p class="mb-0 caption">
                    {{this.$lang.translate('details.dates.plannedEnd')}}
                    {{ _.get(to, 'plannedEnd') | datetime }}
                  </p>
                  <p
                    class="mb-0 caption primary--text"
                    v-if="setActualDate('Last', _.get(to, 'actualEnd'))"
                  >
                    {{this.$lang.translate('details.dates.actualEnd')}}
                    {{setActualDate('Last', _.get(to, 'actualEnd')) | datetime}}
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h4 class="subtitle-2 mb-2">
                    <v-icon size="20" color="#3200E6">
                      mdi-playlist-check
                    </v-icon> Order details</h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-start">
                  <ul class="geodis-data">
                    <li class="geodis-data__item" v-for="d in referencesBySystem" :key="d.uid">
                      <v-row>
                        <v-col class="py-0">
                          <span class="body-2 grey--text">
                            {{ d.lang ? d.lang : d.name }}:
                          </span>
                        </v-col>
                        <v-col class="py-0">
                          <span class="body-2">{{
                            _.get(order, d.alias) || lookForReference(d.alias) || '' }}
                          </span>
                        </v-col>
                      </v-row>
                    </li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col cols="12" md="4" class="map">
      <div v-if="useIoTMap" class="map__holder mb-5">
        <app-map
          :iot="[hits, air]"
          :dest="sites.B"
          :update="sites.uid"
          :done="isComplete(steps.slice().pop())"
        />
      </div>
      <div v-else ref="map" class="map__holder">
        <app-map
          :site-a="sites.A"
          :site-b="sites.B"
          :update="sites.uid"
          :iot="[hits, air]"
        />
      </div>
      <div class="event my-5">
        <h3
        class="grey--text subtitle-2 mb-3"
        >
          <v-icon size="18">mdi-flash-outline</v-icon>
          {{this.$lang.translate('details.titles.lastEvent')}}:
        </h3>
        <v-row>
          <v-col class="flex-grow-0">
            <v-icon :color="status()">mdi-circle-slice-8</v-icon>
          </v-col>
          <v-col>
            <p class="subtitle-1 text-left black--text font-weight-bold mb-0">
              {{
                [
                  translateByScope(_.get(lastEvent, 'description')),
                  !this.scope.name.includes('Thales') ?
                    _.get(lastEvent, 'remarks') || _.get(lastEvent, 'reason')
                    : '',
                ].filter(Boolean).join(' - ')
              }}
            </p>
            <p class="caption mb-0">{{ _.get(lastEvent, 'closeDate') | datetime }}</p>
            <p class="caption mb-0">{{ _.get(lastEvent, 'timezone') }}</p>
            <p class="caption mb-0 grey--text">{{ _.get(lastEvent, 'from.country') }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="justify-center justify-md-start d-flex align-center">
            <v-btn
              color="rgb(50,0,230)"
              variant="primary"
              small
              :to="{ name: `${mode}.business-scope.events`, query: $route.query }"
              class="white--text">
              {{this.$lang.translate('details.titles.allEvents')}}
              <v-icon color="white">mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import { assign, get, values } from 'lodash';
import { uid, oftype } from '@/utils';
import { Setup } from '@/api';
import locationMixin from '@/mixins/location.mixin';

// [deprecated]
import ItineraryModal from '@/components/ItineraryModal.vue';

export default {
  name: 'app-business-scope-details',
  mixins: [locationMixin],
  data() {
    return {
      selected: { hits: [] },
      searched: false,
      icons: [],
      references: [
        {
          uid: uid(),
          name: 'Geodis ID',
          alias: 'shipment',
        },
        {
          uid: uid(),
          name: 'Sales Order',
          alias: 'orderNumber',
        },
        {
          uid: uid(),
          name: 'Delivery order',
          alias: 'customer',
        },
        {
          uid: uid(),
          name: 'Incoterm',
          alias: 'incoterm',
        },
        {
          uid: uid(),
          name: 'Ref2',
          alias: 'hawb',
          custom: {
            KSM: 'Product ref',
          },
        },
        {
          uid: uid(),
          name: 'Order',
          alias: 'order',
          custom: {
            KSM: 'PO number',
          },
        },
        {
          uid: uid(),
          name: 'HAWB',
          alias: 'hawb',
        },
        {
          uid: uid(),
          name: 'Master Air Waybill',
          alias: 'MasterAirwaybill',
        },
        {
          uid: uid(),
          name: 'House Air Waybill',
          alias: 'AirWaybill',
        },
        {
          uid: uid(),
          name: 'Planned Air waybill',
          alias: 'House Air Way Bill',
        },
      ],
    };
  },
  // [deprecated]
  components: {
     ItineraryModal,
 },
  computed: {
    ...mapState({
      iotSelection: 'IoTSelection',
      iotAccess: 'IOTAccess',
      haveDynamicAccess: 'DynamicItineraryAccess',
      result: 'Order',
      scope: 'Scope',
    }),
    mode() {
      return this.$route.name.includes('client') ? 'client' : 'track';
    },
    order() {
      return this.result;
    },
    air() {
      // eslint-disable-next-line
      return this.result.hits ? this.result.hits.filter(h => h._source.air) : [];
    },
    tracker() {
      // eslint-disable-next-line
      return this.result.hits ? this.result.hits.filter(h => h._source.tracker) : [];
    },
    trackerHits() {
      /* eslint-disable */
      return values(this.tracker.reduce((holder, current, i) => {
        const tracker = current._source.tracker;

        if (!holder[tracker.deviceId]) {
          holder[tracker.deviceId] = {
            text: `${this.result.shipment} - ${tracker.deviceId}`,
            value: tracker.deviceId,
            hits: [],
          };
        }
        holder[tracker.deviceId].hits.push(current);

        return holder;
      }, { })).map(v => v);
      /* eslint-enable */
    },
    milestones() {
      return get(this.order, 'orders', []);
    },
    milestoneDates() {
      const pickup = this.milestones.find(
        m => m.type === 'CHARGEMENT' || m.type === 'PICKUP',
      );
      const deliver = this.milestones.find(
        m => m.type === 'DECHARGEME' || m.type === 'DELIVER',
      );
      return {
        plannedEnd: get(deliver, 'dates.plannedEnd', ''),
        plannedStart: get(pickup, 'dates.plannedStart', ''),
        actualEnd: get(deliver, 'dates.actualEnd', ''),
        actualStart: get(pickup, 'dates.actualStart', ''),
      };
    },
    from() {
      return assign(
        get(this.order, 'from'),
        this.scope.system.match('Mpo') ? get(this.order, 'dates') : { },
        this.scope.system.match('Zenith') ? this.milestoneDates : { },
      );
    },
    to() {
      return assign(
        get(this.order, 'to'),
        this.scope.system.match('Mpo') ? get(this.order, 'dates') : { },
        this.scope.system.match('Zenith') ? this.milestoneDates : { },
      );
    },
    steps() {
      const orders = get(this.order, 'orders');
      if (orders) {
        return (oftype(orders, 'Array') ? orders : [orders])
          .filter(o => this.$lang.translate(`details.majorSteps.${o.type}`));
      }
      return [];
    },
    referencesBySystem() {
      if ((this.scope.name || '').toLowerCase().match('thales')) {
        return this.setThalesReferences();
      }

      const cleanReferences = this.references.filter(i => !i.alias.includes('incoterm'));

      return cleanReferences.slice().map((r) => {
        if (r.custom && r.custom[this.scope.name]) {
          // eslint-disable-next-line
          r.name = r.custom[this.scope.name];
        }

        return r;
      });
    },
    lastEvent() {
      return [...this.order.events].filter(e => e.closeDate).pop();
    },
    useIoTMap() {
      return (
        this.result.hits

        // [Deprecated]
        // No longer needed, we want to always display the GPS values even if
        // no IoT access is granted, this doesn't affect IoT tab (still required
        // to have IoT access).
        // && this.iotAccess

        && this.trackerHits[0]
      );
    },
    hits() {
      if (this.useIoTMap) {
        return {
          trackers: this.trackerHits,
        };
      }

      return [];
    },
  },
  methods: {
    /**
     * Works only for Thales (MPO systems), due to some changes we have to
     * obtain the reference value from his references array instead of the main
     * props of the order.
     */
    lookForReference(ref) {
      const search = (target) => {
        if (!target) return undefined;
        // First time that it returns an Object instead of an Array,
        // could be due to some changes from third-party services.
        if (oftype(target, 'Object') && target.alias === ref) {
          return target.value;
        }

        if (oftype(target, 'Array')) {
          return window._.flow([
            v => v.find(o => o.alias === ref),
            v => window._.get(v, 'value'),
          ])(target);
        }

        return '';
      };

      return search(this.order.references)
        || search(this.order.infoEvents);
    },

    /**
     * Only for LVMH, we do a translation of the values that comes from MPO (cuz
     * they are in french in some cases), we only can apply for a certain known
     * values:
     *
     * Retardé -> Delayed
     * Livré -> Delivered
     * Différé -> Departure delay
     * Départ -> Departed
     * Non livré -> Delivery not completed
     *
     * @param {String} comment
     * @returns {String}
     */
    translateByScope(comment) {
      if (this.scope.name === 'LVMH') {
        return {
          Retardé: 'Delayed',
          Livré: 'Delivered',
          Différé: 'Departure delay',
          Départ: 'Departed',
          'Non livré': 'Delivery not completed',
        }[comment] || comment;
      }

      return comment;
    },
    setActualDate(stepConfirmation, date) {
      if (this.steps.length) {
        if (stepConfirmation === 'Last') {
          return this.isComplete(this.steps[this.steps.length - 1]) ? date : null;
        }
        if (stepConfirmation === 'First') {
          return this.isComplete(this.steps[0]) ? date : null;
        }
      }

      return null;
    },
    setThalesReferences() {
      return this.references.slice()
        .filter(
          r => [
            'shipment',
            'customer',
            'incoterm',
            'MasterAirwaybill',
            'AirWaybill',
            'HouseAirWayBill',
          ].includes(r.alias),
        )
        .map((r) => {
          if (
            this.scope.name.includes('Thales')
            && this.$lang.locale.includes('en')
          ) {
            return {
              ...r,
              lang: this.$lang.translate(`details.referencesThales.${r.alias}`),
            };
          }

          return {
            ...r,
            lang: this.$lang.translate(`details.references.${r.alias}`),
          };
        });
    },
    isScope(scope) {
      return this.scope.name.toLowerCase() === scope.toLowerCase();
    },
    isComplete(step) {
      switch (this.scope.system) {
        case 'Zenith':
          return window._.get(step, 'complete') === '1';
        default:
          return window._.get(step, 'dates.actualEnd') !== null;
      }
    },
    complete(step) {
      return this.isComplete(step)
        ? { backgroundColor: '#39b5a1 !important' }
        : {};
    },
    icon(status) {
      const { value } = (this.icons.find(i => i.name === status) || { });
      return value ? `${process.env.VUE_APP_PUBLIC_PATH}icons/${value}` : '';
    },
    status(status) {
      return {
        CLOSED_NORMAL: 'success',
        CLOSED_LATE: 'warning',
      }[status] || 'success';
    },
  },
  async created() {
    const { data: icons } = await Setup.fetch({
      guid: this.scope.guid || this.$route.params.scope,
      type: 'Icon',
    });
    this.icons = icons;
  },
};
</script>
